import { controlAudioAction } from 'actions/controlAudioAction';
import getStore from './getStore';

const store = getStore();

// kill all audio if any is playing
export const killAllAudio = () => {
  store.dispatch(
    controlAudioAction({
      pause: true,
    })
  );
};
